/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Routes, Route, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { hostName } from "../../../App";
import { ClapSpinner } from "react-spinners-kit";
import { useTranslation } from "react-i18next";
import Header from "../../../components/common/Header";
import Sidebar from "../../../components/common/Sidebar";
import OrganizationHome from "../../../components/sites/home/OrganizationHome";
import Pledges from "./pledges/Pledges";
import IndividualPledge from "./pledges/IndividualPledge";
import FulfillPledge from "./pledges/FulfillPledge";
import LiveDisplay from "./pledges/LiveDisplay";

const ParentSite = ({
  userData,
  setLoggedInUserData,
  toggled,
  handleToggle,
  dropdownToggle,
  handleDropdownToggle,
  searchValue,
  setSearchValue,
  searchClass,
  setTaxReceiptModal,
  setLinkDonationModal,
}) => {
  // use t function where ever hard coded text is used
  const { t } = useTranslation();

  // dynamic name of organization
  const { orgName } = useParams();

  // location
  const location = useLocation();

  // is live display route
  const isLiveDisplayRoute =
    /^\/sites\/[^/]+\/livedisplay\/pledgecontrol\/[^/]+$/.test(
      location.pathname
    );

  // match the route and capture tagNumber
  const match = location.pathname.match(
    /^\/sites\/[^/]+\/livedisplay\/pledgecontrol\/([^/]+)$/
  );

  // tagNumber from URL
  const [tagNumber] = useState(match ? match[1] : null);

  // get org states
  const [orgLoading, setOrgLoading] = useState(true);
  const [orgObj, setOrgObj] = useState(null);
  const [orgError, setOrgError] = useState(null);

  // fetch api / get organization obj
  useEffect(() => {
    if (!orgObj) {
      const params = new URLSearchParams({ shortName: orgName });

      if (userData?.email) {
        params.append("email", userData.email);
      }

      axios
        .get(
          `${hostName}api/v1/search/organizationByShortName?${params.toString()}`,
          {
            headers: {
              "X-Local-Access-Token":
                "zrPIG1Q90I0cfPhmBZuH1hQErA1mUvQG7mE4jk3ta8lqBJw1L15TGvqJD5MMxwAO",
            },
          }
        )
        .then((res) => {
          if (res.data?.data) {
            setOrgObj(res.data.data);
          } else {
            setOrgError("No data field found in response");
          }
        })
        .catch((err) => {
          let errorMessage = "An unexpected error occurred. Please try again.";

          if (err.response) {
            // Server responded with a status code outside of the 2xx range
            errorMessage =
              err.response.data?.message || "Server error occurred.";
          } else if (err.request) {
            // Request was made but no response was received
            errorMessage =
              "No response from server. Please check your connection.";
          } else {
            // Something else happened while setting up the request
            errorMessage = err.message;
          }

          setOrgError(errorMessage);
        })
        .finally(() => setOrgLoading(false));
    }
  }, [orgName]);

  // validates pledges route
  const isPledgesRoute = /^\/sites\/[^/]+\/pledges(\/[^/]+)?$/.test(
    location.pathname
  );

  // get pledges states
  const [pledgesLoading, setPledgesLoading] = useState(false);
  const [pledgesArray, setPledgesArray] = useState(null);
  const [pledgesError, setPledgesError] = useState(null);

  // get pledges
  useEffect(() => {
    if (isPledgesRoute && !pledgesArray) {
      setPledgesLoading(true);

      axios
        .get(
          `${hostName}api/v1/search/pledgesByShortName?shortName=${orgName}`,
          {
            headers: {
              "X-Local-Access-Token":
                "zrPIG1Q90I0cfPhmBZuH1hQErA1mUvQG7mE4jk3ta8lqBJw1L15TGvqJD5MMxwAO",
            },
          }
        )
        .then((res) => {
          if (res.data?.data) {
            setPledgesArray(res.data.data);
          } else {
            setPledgesError("No data field found in response");
          }
        })
        .catch((err) => {
          let errorMessage = "An unexpected error occurred. Please try again.";

          if (err.response) {
            // Server responded with a status code outside of the 2xx range
            errorMessage =
              err.response.data?.message || "Server error occurred.";
          } else if (err.request) {
            // Request was made but no response was received
            errorMessage =
              "No response from server. Please check your connection.";
          } else {
            // Something else happened while setting up the request
            errorMessage = err.message;
          }

          setPledgesError(errorMessage);
        })
        .finally(() => setPledgesLoading(false));
    }
  }, [location.pathname, orgName]);

  // state to check if any loading is true
  const [loadings, setLoadings] = useState(orgLoading);

  // update main loadings state
  useEffect(() => {
    setLoadings(orgLoading || pledgesLoading);
  }, [orgLoading, pledgesLoading]);

  return (
    <>
      {isLiveDisplayRoute ? (
        <LiveDisplay tagNumber={tagNumber} />
      ) : (
        <div
          className={userData ? "main-container logged-in" : "main-container"}
        >
          <Header
            hostName={hostName}
            userData={userData}
            setLoggedInUserData={setLoggedInUserData}
            handleToggle={handleToggle}
            dropdownToggle={dropdownToggle}
            handleDropdownToggle={handleDropdownToggle}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            searchClass={searchClass}
            setTaxReceiptModal={setTaxReceiptModal}
            setLinkDonationModal={setLinkDonationModal}
          />
          <div className="dashboard-container">
            <Sidebar userData={userData} toggled={toggled} />
            <div
              className="home-content"
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "12px",
              }}
            >
              {loadings ? (
                <main className="info-content-div" style={{ height: "100%" }}>
                  <ClapSpinner size={30} color="#007c16" loading={loadings} />
                </main>
              ) : orgError ? (
                <main className="info-content-div" style={{ height: "100%" }}>
                  <div className="error-msg" style={{ marginTop: 0 }}>
                    {orgError}
                  </div>
                </main>
              ) : orgObj ? (
                <Routes>
                  {/* Home Page of Organization */}
                  <Route
                    path="/"
                    element={
                      <OrganizationHome
                        orgName={orgName}
                        orgObj={orgObj}
                        setOrgObj={setOrgObj}
                        userData={userData}
                        setLoggedInUserData={setLoggedInUserData}
                        setLoadings={setLoadings}
                        pledgesArray={pledgesArray}
                      />
                    }
                  />

                  {/* pledges */}
                  <Route
                    path="/pledges"
                    element={
                      <Pledges
                        orgName={orgName}
                        orgObj={orgObj}
                        setOrgObj={setOrgObj}
                        userData={userData}
                        setLoggedInUserData={setLoggedInUserData}
                        pledgesArray={pledgesArray}
                        pledgesError={pledgesError}
                      />
                    }
                  />

                  {/* individual pledge */}
                  <Route
                    path="/pledges/:tagNumber"
                    element={
                      <IndividualPledge
                        userData={userData}
                        setLoggedInUserData={setLoggedInUserData}
                        orgName={orgName}
                        orgObj={orgObj}
                        pledgesArray={pledgesArray}
                      />
                    }
                  />

                  {/* fulfill pledge */}
                  <Route
                    path="/fulfillpledge/:code"
                    element={
                      <FulfillPledge
                        setLoggedInUserData={setLoggedInUserData}
                        orgObj={orgObj}
                      />
                    }
                  />

                  {/* not found */}
                  <Route
                    path="*"
                    element={
                      <main
                        className="info-content-div"
                        style={{ height: "100%" }}
                      >
                        <div className="error-msg" style={{ marginTop: 0 }}>
                          {t("pledge.not_found")}
                        </div>
                      </main>
                    }
                  />
                </Routes>
              ) : (
                <main className="info-content-div" style={{ height: "100%" }}>
                  <div className="error-msg" style={{ marginTop: 0 }}>
                    Organization not found
                  </div>
                </main>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ParentSite;
